import styled from 'styled-components'
import CloseIcon from '../../static/images/modal/close.svg'
import CloseIconOffWhite from '../../static/images/modal/close_offwhite.svg'
import CloseHoverIcon from '../../static/images/modal/close_hover.svg'
import CloseHoverIconWhite from '../../static/images/modal/close_hover_white.svg'

export default styled.div`
  position: fixed;
  right: ${props => props.right || '5%'};
  top: 40px;
  height: ${props => props.size || 27}px;
  width: ${props => props.size || 27}px;
  background: ${props =>
    `no-repeat url(${props.offWhiteIcon ? CloseIconOffWhite : CloseIcon})`};
  background-size: contain;
  cursor: pointer;
  transform: translateY(-50%);
  transition: background-image 0.2s ease-in-out;
  @media all and (max-width: 1024px) {
    position: absolute
  }

  &:hover {
    background: no-repeat url(${CloseHoverIcon});
    background-size: contain;
  }

  &.white:hover {
    background: no-repeat url(${CloseHoverIconWhite});
    background-size: contain;
  }
`
